(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ModalTermsController', ModalTermsController);

    ModalTermsController.$inject = ['$uibModalInstance', 'privacy', 'terms', '$scope', '$window'];

    function ModalTermsController($uibModalInstance, privacy, terms, $scope, $window) {
        var vm = this;
        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";

        vm.dismissModal = function () {
            vm.result = {
                privacy: privacy,
                terms: terms
            }
            $uibModalInstance.close(vm.result);
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            terms = true;
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            privacy = true;
        };
    }
})();
